import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import addbooktoserver from "../redux/books/thunk/addBook";
import updateBook from "../redux/books/thunk/updateBook";
import { afterUpdate } from "../redux/update";

function Bookform(){
  const updateform = useSelector(state=>state.update);
  const book = useSelector(state => state.books);
  const dispatch = useDispatch();
  const [isFormUpdate, setIsFormUpdate] = useState(false);
  
  const [inputData, setInputData] = useState({
    name: "",
    author: "",
    thumbnail: "",
    price: "",
    rating: "",
    featured: false,
  });
  const handleInput = (e) => {
    let inputValue = '';  
    switch (e.target.type) {
      case 'text':
        inputValue = e.target.value;
        break;  
      case 'number':
        inputValue = e.target.value === '' ? '' : Number(e.target.value);
        break;  
      case 'checkbox':
        inputValue = e.target.checked;
        break;  
      default:
        break;
    }  
    return inputValue;
  }
  const handleChange = (e)=>{
    const targetInput = e.target;
    const name = targetInput.name; 
    const value = handleInput(e); 
    setInputData((prev)=>{
      return {...prev, [name]:value};
    });
  };  
  const submitHandler = (e) => {
    e.preventDefault(); 
    dispatch(addbooktoserver(inputData));
    setInputData({
      name: "",
      author: "",
      thumbnail: "",
      price: "",
      rating: "",
      featured: false,
    });
  };
  const updateHandler = (e) => {
    e.preventDefault();
    dispatch(updateBook(updateform.id,inputData));    
    setInputData({
      name: "",
      author: "",
      thumbnail: "",
      price: "",
      rating: "",
      featured: false,
    });
    dispatch(afterUpdate());
  }
  useEffect(()=>{
    if(updateform.id){
      const editBookData = book.filter(value => value.id === updateform.id);
      setInputData(editBookData[0]);      
      setIsFormUpdate('true');      
    }
  }, [updateform,book]);
  
  return(
        <div>
        <div className="p-4 overflow-hidden bg-white shadow-cardShadow rounded-md">
          <h4 className="mb-8 text-xl font-bold text-center">{isFormUpdate ? 'Update' : 'Add New'} Book</h4>
          <form onSubmit={isFormUpdate ? updateHandler : submitHandler} className="book-form">
            <div className="space-y-2">
              <label hmtlfor="name">Book Name</label>
              <input required className="text-input" type="text" id="input-Bookname" name="name" value={inputData.name} onChange={handleChange} />
            </div>

            <div className="space-y-2">
              <label hmtlfor="category">Author</label>
              <input required className="text-input" type="text" id="input-Bookauthor" name="author" value={inputData.author} onChange={handleChange} />
            </div>

            <div className="space-y-2">
              <label hmtlfor="image">Image Url</label>
              <input required className="text-input" type="text" id="input-Bookthumbnail" name="thumbnail" value={inputData.thumbnail} onChange={handleChange} />
            </div>

            <div className="grid grid-cols-2 gap-8 pb-4">
              <div className="space-y-2">
                <label hmtlfor="price">Price</label>
                <input required step="any" className="text-input" type="number" id="input-Bookprice" name="price" value={inputData.price} onChange={handleChange} />
              </div>

              <div className="space-y-2">
                <label hmtlfor="quantity">Rating</label>
                <input required className="text-input" type="number" id="input-Bookrating" name="rating" min="1" max="5" value={inputData.rating} onChange={handleChange} />
              </div>
            </div>

            <div className="flex items-center">
              <input id="input-Bookfeatured" type="checkbox" name="featured" className="w-4 h-4" checked={inputData.featured} onChange={handleChange} />
              <label hmtlfor="featured" className="ml-2 text-sm"> This is a featured book </label>
            </div>

            <button type="submit" className="submit" id="submit">{isFormUpdate ? 'Update Book' : 'Add Book'}</button>
          </form>
        </div>
      </div>
    );
}

export default Bookform;